import { useQuery } from '@tanstack/react-query';
import { apiFetchProductCopies } from './apiFetchProductCopies';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';

const PRODUCT_COPIES_QUERY_KEY = 'productCopies';

export const useProductCopies = (productId: string) => {
    return useQuery([PRODUCT_COPIES_QUERY_KEY, productId], () => apiFetchProductCopies(productId), {
        ...GlobalReactQueryOptions,
        retry: false
    });
};

export const invalidateProductCopies = (productId: string) => {
    return browserClient.invalidateQueries({ queryKey: [PRODUCT_COPIES_QUERY_KEY, productId] });
};
